import React from "react";
import { useAppTranslation } from "@/utils";
import { Link, useNavigate } from "react-router-dom";
import { Drawer, Flex, Menu, Space, Typography } from "@payping/web-components";
import { ArrowRightOutlined, FeatherLeft, FiLock, FiMessageCircle, PhosphorProfile } from "@payping/icons";
import { DashboardRoutes } from "@/router/constant";
import { changePassCardId, notificationCardId, twoFACardId } from "@/assets/googleTrackIds";
import { useAtom } from "jotai";
import { selectAtom } from "jotai/utils";
import { coreAtom } from "@/core/state/root";

const firstUrlToSettingsAndProfileAtom = selectAtom(coreAtom, (val) => val.firstUrlToSettingsAndProfile);

const MobileProfileMenu: React.FC = () => {
  const { t } = useAppTranslation();
  const [firstUrlToSettingsAndProfile] = useAtom(firstUrlToSettingsAndProfileAtom);

  const navigate = useNavigate();

  return (
    <Drawer
      placement={"bottom"}
      open={true}
      closable={false}
      height={"100%"}
      title={
        <Space>
          <ArrowRightOutlined
            width={14}
            onClick={() => {
              navigate(firstUrlToSettingsAndProfile);
            }}
          />
          {t("profile.title")}
        </Space>
      }
    >
      <Flex className={"tw-my-7"} vertical={true}>
        <Typography.Title level={4} className={"tw-mb-8"}>
          {t("profileMenu.profile")}
        </Typography.Title>

        <Menu className="tw-border-0" mode={"inline"}>
          {/* < پروفایل > */}
          <Menu.Item>
            <div className={"tw-flex tw-justify-between"}>
              <Link to={DashboardRoutes.profile.detail.url}>
                <Space>
                  <PhosphorProfile width={14} />
                  {t("profile.profile")}
                </Space>
              </Link>
              <FeatherLeft width={14} />
            </div>
          </Menu.Item>
          <Menu.SubMenu
            key={"security"}
            title={
              <Space>
                <FiLock width={14} strokeWidth={1.5} />
                <Typography.Text>{t("profile.security")}</Typography.Text>
              </Space>
            }
          >
            <Menu.Item>
              <div className={"tw-flex tw-justify-between"}>
                <Link to={DashboardRoutes.profile.password.url} data-google-track={changePassCardId}>
                  {t("profile.password")}
                </Link>
                <FeatherLeft width={14} />
              </div>
            </Menu.Item>
            <Menu.Item>
              <div className={"tw-flex tw-justify-between"}>
                <Link to={DashboardRoutes.profile.m2fa.menu.url} data-google-track={twoFACardId}>
                  {t("profile.twoStepPassword")}
                </Link>
                <FeatherLeft width={14} />
              </div>
            </Menu.Item>
            <Menu.Item>
              <div className={"tw-flex tw-justify-between"}>
                <Link to={DashboardRoutes.profile.client.url}>{t("profile.accesses")}</Link>
                <FeatherLeft width={14} />
              </div>
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.Item>
            <div className={"tw-flex tw-justify-between"}>
              <Link to={DashboardRoutes.profile.messaging.url} data-google-track={notificationCardId}>
                <Space>
                  <FiMessageCircle width={14} strokeWidth={1.5} />
                  {t("profile.messaging")}
                </Space>
              </Link>
              <FeatherLeft width={14} />
            </div>
          </Menu.Item>

          {/* تنظیمات نمایش */}
          {/*
          <Divider className={"mt-0"} />
          <Menu.Item>
            <div className={"tw-flex tw-justify-between"}>
              <Link to={DashboardRoutes.profile.display.url}>{t("profile.displaySetting")}</Link>
              <LeftOutlined width={14} />
            </div>
          </Menu.Item>
          */}
        </Menu>
      </Flex>
    </Drawer>
  );
};

export default MobileProfileMenu;
